import { Breadcrumb, Row, Col, Card, Button } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faEdit, faHome, faMobile, faTrash } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react'
import { Modal, Form, Card as AntCard, Button as AntButton, Upload, Input } from 'antd';
import { ExclamationCircleOutlined, InboxOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useRecoilValueLoadable, useSetRecoilState } from 'recoil';
import { Editor } from "react-draft-wysiwyg";
import { EditorState } from "draft-js";
import { settingAlert, settingResponse, settings, settingsRefresh } from '../../../states/settings';
import { aboutEditor, aboutEditorDesc, aboutRefresh, abouts, editAboutModal, editABoutVal } from '../../../states/about';
import { getHtml, getRawData } from '../../../services/utilities';
import { deleteAbout, updateSettings } from '../../../services/apiCalls';
import AlertToast from '../../../components/AlertToast';
import { dummyRequest } from '../../../services/utilities';
import AboutModal, { EditModal } from './Modal';
import { createAboutModal } from '../../../states/about';
import { imageUrl } from '../../../services/axios';

const { Meta } = AntCard;
const About = () => {
  const data = useRecoilValueLoadable(settings)
  const about = useRecoilValue(abouts)
  // const about = useRecoilValueLoadable(abouts)
  const [showAlert, setShowAlert] = useRecoilState(settingAlert);
  const [response, setResponse] = useRecoilState(settingResponse)
  const setCreateModal = useSetRecoilState(createAboutModal);
  const setUpdateModal = useSetRecoilState(editAboutModal);
  const setRefresh = useSetRecoilState(settingsRefresh)
  const setAboutRefresh = useSetRecoilState(aboutRefresh)
  const setValue = useSetRecoilState(editABoutVal)
  // const aboutData = about.state === "hasValue" && about.contents ? about.contents : []
  // const aboutData = about.state === "hasValue" && about.contents ? about.contents : []
  const settingData = data.state === "hasValue" ? data.contents : {}
  const { aboutContents, aboutOthers } = about && about 
  const [viewModal, setViewModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [file, setFile] = useState("")
  const [form] = Form.useForm()
  const [editor, setEditor] = useState("")
  const setEditorAbt = useSetRecoilState(aboutEditor)
  const setEditorDesc = useSetRecoilState(aboutEditorDesc)
  const { confirm } = Modal;

  const handleUpdate = () => {
    if (settingData.about_us) {
      const contentState = getRawData(settingData.about_us)
      setEditor(EditorState.createWithContent(contentState));
    }
    setViewModal(true)
  }

  const handleEditModal = (val) => {
    console.log(val.content)
    setUpdateModal(true)
    if (val.title) {
      const contentState = getRawData(val.title)
      setEditorAbt(EditorState.createWithContent(contentState));
    }
    if (val.content) {
      const contentStateDesc = getRawData(val.content)
      setEditorDesc(EditorState.createWithContent(contentStateDesc));
    }
    setValue(val)
    setResponse({})
  }  
  const onFinishUpdate = async (val) => {
    const date = new Date()
    const fd = new FormData();
    fd.append('about_us', getHtml(editor))
    fd.append('about_image', file);
    fd.append('id', val.id);
    setLoading(true)
    const res = await updateSettings({ data: fd, type: "about" })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      setEditor("")
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };

  const confirmDelete = (id) => {
    confirm({
      title: `Are you sure you want to delete this Post?`,
      icon: <ExclamationCircleOutlined />,
      content: 'Click Ok to continue',
      onOk() {
        handleDelete(id)
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleDelete = async (id) => {
    const date = new Date()
    const res = await deleteAbout(id)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setAboutRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }
  
  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="About" />
      <AboutModal />
      <EditModal />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>About</Breadcrumb.Item>
          </Breadcrumb>
          <h4>About Us Page</h4>
        </div>
      </div>
      <div className="table-settings mb-4">
        <Button variant="secondary" className="text-white me-3" onClick={handleUpdate}>
          Update About Us<FontAwesomeIcon icon={faAddressCard} className="d-none d-sm-inline ms-1" />
        </Button>
        <Button variant="success" className="text-white me-3" onClick={() => setCreateModal(true)}>
          Create New Feature Content <FontAwesomeIcon icon={faMobile} className="d-none d-sm-inline ms-1" />
        </Button>
      </div>
      <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <Row>
            <h5 className="mb-4 text-primary text-center">About Waya Group</h5>
            <Col xs={12} md={7} xl={7} lg={7}>
              <p className='text-center' dangerouslySetInnerHTML={{ __html: settingData.about_us }} />
            </Col>
            <Col xs={12} md={5} xl={5} lg={5}>
              <img alt="Wayapaychat" src={`${settingData.about_image}`} />
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Row>
        {aboutContents && aboutContents &&
        aboutContents.map((b, index) => (
          <Col key={index} xs={12} xl={4} lg={4} md={4}>
            <AntCard
              hoverable
              style={{ width: 240 }}
              cover={<img alt="features" src={`${b.image_url}`} />}
            >
              {/* <Meta title={b.title} description={b.content} /> */}
              <p dangerouslySetInnerHTML={{ __html: b.title }} />
              <p dangerouslySetInnerHTML={{ __html: b.content }} />
              <Button size="sm" variant="success" className="text-white m-3" onClick={() => handleEditModal(b)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
              <Button size="sm" variant="primary" className="text-white m-3" onClick={() => confirmDelete(b.id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
            </AntCard>
          </Col>))}
      </Row>
      <Row>
        {aboutOthers && aboutOthers &&
        aboutOthers.map((b, index) => (
          <Col key={index} xs={12} xl={12} lg={12} md={12} className="text-center my-2">
            <p className="mb-4 text-primary text-center" dangerouslySetInnerHTML={{ __html: b.title }} />
            <p className="text-center" dangerouslySetInnerHTML={{ __html: b.content }} />
              <Button size="sm" variant="success" className="text-white me-2" onClick={() => handleEditModal(b)}>
                <FontAwesomeIcon icon={faEdit} />
              </Button>
              <Button size="sm" variant="primary" className="text-white" onClick={() => confirmDelete(b.id)}>
                <FontAwesomeIcon icon={faTrash} />
              </Button>
          </Col>))}
      </Row>
      {/* About Content start */}
      <Modal
        title="Update About Us"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical">
          <Form.Item label="About Us" name="about_us" rules={[{ required: true }]}>
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 200,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item name="id" initialValue={settingData.id}>
            <Input />
          </Form.Item>
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Image</AntButton>
            </Upload>
          </Form.Item>
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* About Content end */}
    </div>
  )
}

export default About
